var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrSprinklers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    style: {
      fill: "var(--bg-color, none)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.829 26.5h2.312v-5.954h-14.32V26.5h2.312v8.222h-5.1v1.667h20.239v-1.665h-5.443zm-10.342-1.664v-2.624h10.987v2.623h-2.312v9.883H18.8v-9.882zm14.132-11.665-1.178-1.178 1.178-1.178 1.181 1.177zm-2.357-4.714 1.178 1.178-1.178 1.178-1.178-1.177zm5.892 5.892-1.178 1.178-1.176-1.178 1.178-1.178zm-3.81-10.427-1.178-1.178 1.178-1.178 1.178 1.178zM32.7 1.566 31.522.387 32.7-.791 33.881.387zm-4.713 4.713L26.809 5.1l1.178-1.178L29.166 5.1zm12.655 1.673h-1.666V6.286h1.667zm-5-1.667h1.667v1.667h-1.667zm-5 1.667h-1.666V6.286h1.667zm1.667-1.667h1.667v1.667h-1.667zm-6.695 3.282h-7.267V4.631h7.267zm-.443 1.07h-6.38v8.912h6.38zM20.457 12.3H23.5v5.578h-3.043z",
    transform: "translate(8.019 5.606)",
    style: {
      fill: "var(--color, #9ea1a2)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(6 40)",
    style: {
      fontSize: 16,
      fontWeight: 700,
      letterSpacing: ".025em",
      fill: "var(--color, #9ea1a2)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 13.75,
    y: 15
  }, "GR"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.463 1.463)",
    style: {
      stroke: "var(--color, #9ea1a2)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.537,
    cy: 28.537,
    r: 28.537,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.537,
    cy: 28.537,
    r: 28.037,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrSprinklers);
export default __webpack_public_path__ + "static/media/gr_sprinklers.a3829019b49a2e45df9d8cf0123f00c6.svg";
export { ForwardRef as ReactComponent };